function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { Label } from "../Form";
import TextFieldInput from "./TextFieldInput";
import TextFieldTextarea from "./TextFieldTextarea";
const TextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { id , labelText , placeholder , value , onChange , onKeyDown , onFocus , maxLength , disabled , helperText , error , errorText , className: classNameProp , name , multiline , autoFocus ,  } = props;
    const inputId = `${id}-input`;
    const labelId = `${id}-label`;
    const className = clsx(classNameProp, {
        error
    });
    const hintText = error && errorText || !error && helperText;
    const sharedProp = {
        maxLength,
        id: inputId,
        "aria-labelledby": labelId,
        placeholder,
        value,
        onChange,
        onKeyDown,
        onFocus,
        autoComplete: "off",
        name,
        autoFocus,
        disabled
    };
    return /*#__PURE__*/ _jsxs(Flex, {
        flexDirection: "column",
        className: className,
        flex: "1 0 auto",
        children: [
            /*#__PURE__*/ _jsx(Box, {
                mb: "8px",
                children: /*#__PURE__*/ _jsx(Label, {
                    htmlFor: inputId,
                    id: labelId,
                    children: labelText
                })
            }),
            multiline ? /*#__PURE__*/ _jsx(TextFieldTextarea, _objectSpread({
                ref: ref
            }, sharedProp)) : /*#__PURE__*/ _jsx(TextFieldInput, _objectSpread({
                ref: ref
            }, sharedProp)),
            hintText && /*#__PURE__*/ _jsx(Box, {
                mt: "8px",
                children: /*#__PURE__*/ _jsx(Text, {
                    as: "span",
                    fontSize: 1,
                    color: error ? "#ff1744" : "black.60",
                    children: hintText
                })
            })
        ]
    });
});
export default TextField;
